import { useEffect, useState } from 'react';

export function useMounted() {
   const [mounted, setMounted] = useState(false);

   useEffect(() => {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setMounted(true);
      return () => setMounted(false);
   }, []);

   return mounted;
}
